import React, {Component} from 'react';
const { __ } = wp.i18n;

export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchActive: false,
            value: '',
            results: [],
            countLetters: document.querySelector('.app-search').getAttribute('data-letters'),
            countShow: document.querySelector('.app-search').getAttribute('data-show'),
            groupResult: document.querySelector('.app-search').getAttribute('data-group') === 'true' ? true : false,
            isLoader: false
        };

        //  Bindings
        this.handleToggleSearch = this.handleToggleSearch.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target) &&
            document.querySelector('.search-wrapper.open') !== null &&
            event.target.classList.value !== 'search-btn_open-popup'
        ) {
            this.setState({
                searchActive: false
            });
        }
    }

    handleFetchResults(event) {
        const lang = document.documentElement.lang;
        fetch(`${window.location.origin}/wp-json/sso/v1/sso-search/?args=${event.target.value}&lang=${lang.substring(0, 2)}`)
            .then(res => {
                return res.json();
            })
            .then(data => {
                this.setState({
                    results: data,
                    value: event.target.value,
                    isLoader: false
                })
            });
    }

    handleChange(event) {
        event.persist();
        if (event.target.value.length >= this.state.countLetters) {
            this.setState({
                isLoader: true
            });

            this.handleFetchResults(event);

        } else {
            this.setState({
                isLoader: false,
                results: []
            });
        }
    }

    handleToggleSearch(event) {
        event.preventDefault();
        document.querySelector('.search-wrapper input.search-box').focus();
        this.setState({
            searchActive: !this.state.searchActive
        });
    }




    renderGroup() {
        const { results } = this.state;
        if (results.length) {
            return results.map((item, index) =>
                <div className="group" key={index}>
                    {item.type === 'alternative' ? (
                        <p className="group_title">
                            { jsTranslations.didYouMean }
                        </p>
                    ) : (
                        <p className="group_title">
                            {item.type} <span className="count">{item.data.length}</span>
                        </p>
                    )}
                    {this.renderResults(item.data)}
                </div>
            )
        } else {
            return false;
        }
    }

    renderResults(results) {
        const { countShow } = this.state;

        if (results.length) {
            return results.filter((item, i, arr) => {
                return i+1 <= countShow;
            }).map((item, index) =>
                 <a className="result-search" href={item.link} target="_blank" key={index}>
                    {item.image ? (
                        <img src={item.image} />
                    ) : (
                        <div className="img-not_found" />
                    )}
                    <div className="info">
                        <p className="info_title">{item.title}</p>
                        {item.price && (
                            <p className="info_price" dangerouslySetInnerHTML={{__html: item.price}}/>
                        )}
                    </div>
                </a>
            )
        } else {
            return false;
        }

    }



    render() {
        const {searchActive, value, isLoader, groupResult, results} = this.state;
        let searchUrl = [`${window.location.origin}/?s=${value}`];

        return (<React.Fragment>
            <button className="search-btn_open-popup" onClick={this.handleToggleSearch}>
                <span className="ico ico-search"/>
            </button>
            <div className={searchActive ? 'search-wrapper open' : 'search-wrapper'} ref={this.setWrapperRef}>
                <div className="form-control">
                    <input className="search-box" type="text" placeholder={ jsTranslations.search } onChange={(e) => this.handleChange(e)}/>
                    <span className="ico ico-search search-box-placeholder"/>
                </div>
                {isLoader ? <div className="loaders"><div/><div/><div/><div/></div> : <div className="search-results">
                    {groupResult ? this.renderGroup() : this.renderResults(results)}
                    <h3 className="cannotfind">{ jsTranslations.tooltip }</h3>
                    <a href={searchUrl} className="btn btn--primary">{ jsTranslations.seeAllResults }</a>
                </div>}
            </div>
        </React.Fragment>)
    }
}